import { DELETE, GET, POST, PUT } from "@/utils/http";

const APPROVER_BASE_URI = "/product";
// const CUSTOMER_BASE_URI = '/api/customer/product';

export const ProductService = {
  create(
    request: CreateProductRequest,
  ): Promise<SuccessResponse | null | undefined> {
    return POST<SuccessResponse>(
      `${APPROVER_BASE_URI}/create`,
      request,
      undefined,
      true,
    );
  },
  update(
    productCode: string,
    request: CreateProductRequest,
  ): Promise<SuccessResponse | null | undefined> {
    return PUT<SuccessResponse>(`${APPROVER_BASE_URI}/edit`, request, {
      params: { productCode: productCode },
    });
  },
  getDetail(productCode: string): Promise<ProductDetail | null | undefined> {
    return GET<ProductDetail>(
      `${APPROVER_BASE_URI}/detail/${productCode}`,
      undefined,
      true,
    );
  },
  delete(productCode: string): Promise<SuccessResponse | null | undefined> {
    return DELETE<SuccessResponse>(
      `${APPROVER_BASE_URI}/delete/${productCode}`,
    );
  },
  search(
    request: SearchUserListRequest,
  ): Promise<SearchProductResponse | null | undefined> {
    return POST<SearchProductResponse>(`${APPROVER_BASE_URI}/search`, request);
  },
  generateProductCode(): Promise<string | null | undefined> {
    return GET<string>(`${APPROVER_BASE_URI}/generate-code`);
  },
  getProductOptions(): Promise<ProductOption[] | null | undefined> {
    return GET<ProductOption[]>(`${APPROVER_BASE_URI}/get-option`);
  },
};
